










































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Game,
  LogRegForm,
  User,
  GameConfiguration,
  Player,
  FriendRequest,
  HelpContent
} from "@/models/simple-war";
import { ErrorMessages, ToastType } from "@/utils/constants";
import GameBoardComponent from "@/components/GameBoardComponent.vue";
import GamesListComponent from "@/components/GamesListComponent.vue";
import PlayersListComponent from "@/components/PlayersListComponent.vue";
import RequestsListComponent from "@/components/RequestsListComponent.vue";
import ToastActionComponent from "@/components/ToastActionComponent.vue";
import { getAgoTime } from "../utils/utilities";
import * as bcrypt from "bcryptjs";
import * as Stomp from "stompjs";
import SockJS from "sockjs-client";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast);

@Component({
  components: {
    GameBoardComponent,
    GamesListComponent,
    PlayersListComponent,
    RequestsListComponent,
    ToastActionComponent
  }
})
export default class SimpleWarView extends Vue {
  
  public SESSION_TOKEN_STR: string = "Session-Token";

  public showGamesList: boolean = true;
  public showGameBoard: boolean = false;
  public showMyFriends: boolean = false;
  public showMyProfile: boolean = false;
  public showAddFriends: boolean = false;

  public isAuthenticated: boolean = false;
  public showLoginForm: boolean = false;
  public showRegisterFrom: boolean = false;
  public showGuestMessage: boolean = false;
  public showOverview: boolean = false;
  public showSnackbar: boolean = false;
  public snackbarDuration: number = 4000;
  public snackbarType: string = "";
  public snackbarMessage: string = "";

  public showAdvancedConfig: boolean = false;
  public advancedGameConfigs: GameConfiguration = new GameConfiguration();

  public sending: boolean = false;

  public form: LogRegForm = new LogRegForm();
  public user: User = new User();

  public games: Game[] = [];
  public waiting: Game[] = [];
  public pending: Game[] = [];
  public completed: Game[] = [];

  public selectedGame: Game = new Game();
  public selectedGameId: string = "";

  public playerToInvite: string = "";
  public isInviteAdvanced: boolean = false;

  public player: Player = new Player();
  public friends: Player[] = [];
  public incomingRequests: FriendRequest[] = [];
  public outgoingRequests: FriendRequest[] = [];

  public friendUsernameSearch: string = "";
  public friendSearchResults: Player[] = [];

  private stompClient!: Stomp.Client;
  private opponentPutCardSubscription!: Stomp.Subscription;
  private opponentEndTurnSubscription!: Stomp.Subscription;
  private friendRequestReceivedSubscription!: Stomp.Subscription;
  private friendRequestResponseSubscription!: Stomp.Subscription;
  private invitedToGameSubscription!: Stomp.Subscription;

  public host: string = process.env.VUE_APP_SIMPLE_WAR_HOST!;

  private helpContent: HelpContent = new HelpContent();

  constructor() {
    super();
    console.log("SimpleWarView constructor");
    console.log(`Running in ${process.env.NODE_ENV}`);
    console.log(`SimpleWar host: ${this.host}`);
  }

  public mounted() {
    console.log("SimpleWarView mounted");

    // console.log('mounted SimpleWar');
    const sessionToken = this.$cookies.get(this.SESSION_TOKEN_STR);
    // console.log('sessionToken=', sessionToken);

    if (sessionToken) {
      // console.log('sessionToken exists, validating token from server');
      this.sending = true;
      this.$http.get(`${this.host}/users/${sessionToken}`, sessionToken).then(
        result => {
          if (result.ok && result.data) {
            this.$cookies.set(this.SESSION_TOKEN_STR, result.data.sessionToken);
            this.user = result.data;
            this.isAuthenticated = true;
            // console.log(
            // `successfully validated user sessionToken: ${this.user.username}`,
            // );
            this.getGames();
            this.getDefaultConfigs();
            this.initializeWebSocketConnection();
          } else {
            this.isAuthenticated = false;
            throw new Error(JSON.stringify(result));
          }
          this.sending = false;
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
          this.isAuthenticated = false;
          this.sending = false;
        }
      );
    } else {
      // console.log('sessionToken does not exist');
      this.isAuthenticated = false;
    }
  }

  public showSuccessSnackbar(message: string) {
    this.snackbarMessage = message;
    this.snackbarType = "SUCCESS";
    this.showSnackbar = true;
  }

  public showWarningSnackbar(message: string) {
    this.snackbarMessage = message;
    this.snackbarType = "WARNING";
    this.showSnackbar = true;
  }

  public getGames() {
    console.log("getGames");

    this.games = [];
    this.waiting = [];
    this.pending = [];
    this.completed = [];
    // console.log('getting games for user:', this.user.username);
    this.$http
      .get(`${this.host}/games`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            // console.log(
            // `got ${result.data.length} games for ${this.user.username}`,
            // );
            result.data.forEach((g: Game) => {
              if (g.status === "COMPLETED") {
                this.completed.push(g);
              } else if (g.opponentName === "<TBD>" && !g.currentTurn) {
                this.pending.push(g);
              } else if (!g.currentTurn) {
                this.waiting.push(g);
              } else {
                this.games.push(g);
              }
            });
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public getDefaultConfigs() {
    console.log("getDefaultConfigs");

    this.$http.get(`${this.host}/games/default-configs`).then(
      result => {
        if (result.ok && result.data) {
          this.advancedGameConfigs = result.data;
          this.advancedGameConfigs.isAdvanced = true;
        } else {
          throw new Error(JSON.stringify(result));
        }
      },
      error => {
        this.showWarningSnackbar(error.body.message);
      }
    );
  }

  public initializeWebSocketConnection() {
    console.log("initializeWebSocketConnection");

    let ws: WebSocket = new SockJS(`${this.host}/socket/`);
    this.stompClient = Stomp.over(ws);

    this.stompClient.connect({}, () => {
      this.opponentPutCardSubscription = this.stompClient.subscribe(
        `/topic/opponentPutCard/${this.user.username}`,
        (message: Stomp.Message) => {
          console.log("got opponentPutCard message");
          if (message.body) {
            if (this.showGameBoard) {
              (this.$refs
                .gameBoardComponent as GameBoardComponent).updateGameManually(
                this.selectedGameId
              );
            }
          }
        }
      );

      this.opponentEndTurnSubscription = this.stompClient.subscribe(
        `/topic/opponentEndedTurn/${this.user.username}`,
        (message: Stomp.Message) => {
          if (message.body) {

            let msgObj = JSON.parse(message.body);

            if (this.showGamesList) {
              this.getGames();
            } else if (this.showGameBoard) {
              (this.$refs
                .gameBoardComponent as GameBoardComponent).updateGameManually(
                this.selectedGameId
              );
            }

            if (!this.showGameBoard && this.selectedGameId !== msgObj.gameId) {
              // TODO - action to go to game
              this.$toast.info(`It is now your turn in Simple War against ${msgObj.username}!`);
            }
          }
        }
      );

      this.friendRequestReceivedSubscription = this.stompClient.subscribe(
        `/topic/friendRequestReceived/${this.user.username}`,
        (message: Stomp.Message) => {
          if (message.body) {

            let msgObj = JSON.parse(message.body);

            if (this.showMyProfile) {
              this.getRequests();
            }

            // TODO - actions to accept/decline
            this.$toast.info(`${msgObj.username} sent you a friend request!`);

          }
        }
      );

      this.friendRequestResponseSubscription = this.stompClient.subscribe(
        `/topic/friendRequestResponse/${this.user.username}`,
        (message: Stomp.Message) => {
          console.log("got friendRequestResponse message");
          if (message.body) {
            
            let msgObj = JSON.parse(message.body);

            if (this.showMyProfile) {
              this.getFriends();
              this.getRequests();
            }

            this.$toast.info(`${msgObj.username} ${msgObj.response} your friend request!`);
          }
        }
      );

      this.invitedToGameSubscription = this.stompClient.subscribe(
        `/topic/invitedToGame/${this.user.username}`,
        (message: Stomp.Message) => {
          console.log("got invitedToGame message");
          if (message.body) {

            let msgObj = JSON.parse(message.body);

            if (this.showGamesList) {
              this.getGames();
            }

            // TODO - add action to go to game
            this.$toast.info(`${msgObj.username} invited you to a Simple War!`);
          }
        }
      );
    });
  }

  public getGameById() {
    // console.log(`getting data for gameId=${this.selectedGameId}`);
    this.$http
      .get(`${this.host}/games/${this.selectedGameId}`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            this.selectedGame = result.data;
            this.selectedGameId = result.data.id;
            // console.log(`updated data for gameId=${this.selectedGameId}`);
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public addNew() {
    // console.log('plus button clicked');

    if (this.showGamesList) {
      this.newGame();
    } else if (this.showMyProfile) {
      this.addFriend();
    }
  }

  public newGame() {
    // console.log(`create DEFAULT new game for user=${this.user.username}`);
    this.$http
      .get(`${this.host}/games/createOrJoin`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            if (result.data.createOrJoin === "CREATE") {
              // console.log('CREATED new game');
              this.showSuccessSnackbar("Successfully created a Simple War");
            } else {
              // console.log('JOINED game');
              this.showSuccessSnackbar("Successfully joined a Simple War");
            }
            this.selectedGame = result.data.game;
            this.selectedGameId = result.data.game.id;
            this.showGameBoard = true;
            this.showGamesList = false;
            this.showMyFriends = false;
            this.showMyProfile = false;
            // console.log(
            // `added newly created game with gameId=${result.data.game.id}`,
            // );
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public newAiGame() {
    // console.log(`create new game AI for user=${this.user.username}`);
    this.$http
      .post(
        `${this.host}/games/new?ai=true`,
        {},
        {
          headers: {
            "Session-Token": this.user.sessionToken
          }
        }
      )
      .then(
        result => {
          if (result.ok && result.data) {
            this.showSuccessSnackbar(
              "Successfully created a Simple War against AI"
            );
            this.selectedGame = result.data;
            this.selectedGameId = result.data.id;
            this.showGameBoard = true;
            this.showGamesList = false;
            this.showMyFriends = false;
            this.showMyProfile = false;
            // console.log(
            // `added newly created game with gameId=${result.data.id}`,
            // );
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public addFriend() {
    // console.log('show add friends dialog');
    this.showAddFriends = true;
  }

  public requestFriend(friend: Player) {
    // console.log(`requesting ${friend.username} to be friends`);

    this.$http
      .post(
        `${this.host}/players/friends/requests`,
        { requestee: friend.username },
        {
          headers: {
            "Session-Token": this.user.sessionToken
          }
        }
      )
      .then(
        result => {
          if (result.ok && result.status === 200) {
            // console.log('successfully sent friend request');
            this.showSuccessSnackbar(
              `Sent friend request to ${friend.username}`
            );
            this.getPlayerData();
            this.getFriends();
            this.getRequests();
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
          this.getPlayerData();
          this.getFriends();
          this.getRequests();
        }
      );

    this.showAddFriends = false;
  }

  public respondFriend(requestId: string, isAccept: boolean) {
    // console.log(`responding to requestId=${requestId}, isAccept=${isAccept}`);

    this.$http
      .put(
        `${this.host}/players/friends/responses`,
        { requestId, isAccept },
        {
          headers: {
            "Session-Token": this.user.sessionToken
          }
        }
      )
      .then(
        result => {
          if (result.ok && result.status === 200) {
            // console.log('successfully responded to');
            this.showSuccessSnackbar(`Responded to friend request`);
            this.getPlayerData();
            this.getFriends();
            this.getRequests();
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
          this.getPlayerData();
          this.getFriends();
          this.getRequests();
        }
      );
  }

  @Watch("friendUsernameSearch")
  public friendUsernameSearchChange(newValue: string, oldValue: string) {
    if (newValue) {
      // console.log(`search for users with username containing; '${newValue}'`);
      this.$http
        .get(`${this.host}/players/search?query=${newValue}`, {
          headers: {
            "Session-Token": this.user.sessionToken
          }
        })
        .then(
          result => {
            if (result.ok && result.data) {
              this.friendSearchResults = result.data;
              // console.log(
              // `found ${this.friendSearchResults.length} friends from search`,
              // );
            } else {
              throw new Error(JSON.stringify(result));
            }
          },
          error => {
            // console.log(error);
            this.showWarningSnackbar(error.body.message);
          }
        );
    } else {
      this.friendSearchResults = [];
    }
  }

  public goToGameHandler(game: Game) {
    // console.log(`handling goToGame event for gameId=${game.id}`);
    this.selectedGame = game;
    this.selectedGameId = game.id;

    this.showGameBoard = true;
    this.showGamesList = false;
    this.showMyFriends = false;
    this.showMyProfile = false;
  }

  public goToMyProfile() {
    // console.log('showing my profile');
    this.getPlayerData();
    this.getFriends();
    this.getRequests();
    this.showGameBoard = false;
    this.showGamesList = false;
    this.showMyFriends = false;
    this.showMyProfile = true;
  }

  public getPlayerData() {
    // console.log('getting player profile...');

    this.$http
      .get(`${this.host}/players/one`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            this.player = result.data;
            // console.log(`successfully retreived player details`);
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public getFriends() {
    // console.log('getting friends...');

    this.$http
      .get(`${this.host}/players/friends`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            this.friends = result.data;
            // console.log(
            // `successfully retreived ${this.friends.length} friends`,
            // );
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public getRequests() {
    // console.log('getting requests...');

    this.incomingRequests = [];
    this.outgoingRequests = [];

    this.$http
      .get(`${this.host}/players/friends/requests`, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.data) {
            result.data.forEach((r: FriendRequest) => {
              if (r.requester === this.user.username) {
                this.outgoingRequests.push(r);
              } else {
                this.incomingRequests.push(r);
              }
            });
            // console.log(
            // `successfully retreived ${this.outgoingRequests.length} outgoingRequests`,
            // );
            // console.log(
            // `successfully retreived ${this.incomingRequests.length} incomingRequests`,
            // );
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public inviteToGameHandler(username: string, isAdvanced: boolean) {
    this.playerToInvite = username;
    this.isInviteAdvanced = isAdvanced;

    if (isAdvanced) {
      this.showAdvancedConfig = true;
    } else {
      this.newInvitedGame();
    }
  }

  public cancelAdvancedConfig() {
    // console.log('cancel advanced config');
    this.showAdvancedConfig = false;
  }

  public confirmAdvancedConfig() {
    // console.log('confirm advanced config');
    this.validateAdvancedGameConfigs();
  }

  public validateAdvancedGameConfigs() {
    // console.log(
    // `validate advanced game configs: ${JSON.stringify(
    // this.advancedGameConfigs,
    // )}`,
    // );
    this.$http
      .post(`${this.host}/games/new/validate`, this.advancedGameConfigs, {
        headers: {
          "Session-Token": this.user.sessionToken
        }
      })
      .then(
        result => {
          if (result.ok && result.status === 200) {
            // console.log(`successfully validated advanced game configs`);
            // console.log(result);
            this.showAdvancedConfig = false;
            this.newInvitedGame();
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
  }

  public newInvitedGame() {
    // console.log(`inviting ${this.playerToInvite} to game, isAdvanced`);
    this.$http
      .post(
        `${this.host}/games/invite`,
        {
          player2: this.playerToInvite,
          isAdvanced: this.isInviteAdvanced,
          gameConfiguration: this.advancedGameConfigs
        },
        {
          headers: {
            "Session-Token": this.user.sessionToken
          }
        }
      )
      .then(
        result => {
          if (result.ok && result.data) {
            this.selectedGame = result.data;
            this.selectedGameId = result.data.id;
            this.showGameBoard = true;
            this.showMyProfile = false;
            this.showSuccessSnackbar(
              `Invited ${this.selectedGame.opponentName} to a Simple War!`
            );
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        error => {
          // console.log(error);
          this.showWarningSnackbar(error.body.message);
        }
      );
    this.playerToInvite = "";
    this.isInviteAdvanced = false;
  }

  public updateGameBoard(updatedGame: Game) {
    // console.log(
    // `[SimpleWarView] got event to update game with gameId=${updatedGame.id}`,
    // );
    this.selectedGame = updatedGame;
    this.selectedGameId = updatedGame.id;
  }

  public goToGamesList() {
    // console.log('go to games list');
    this.getGames();
    this.showGameBoard = false;
    this.showGamesList = true;
    this.showMyFriends = false;
    this.showMyProfile = false;
  }

  public nextActiveGame() {
    // console.log('next active game');
    this.getGames();

    // console.log('testing if async got here...');
    const currentGameId = this.selectedGameId;
    let nextGameId = "";

    for (const g of this.games) {
      if (g.currentTurn && g.id !== this.selectedGameId) {
        // console.log(`found next active gameId=${g.id}`);
        nextGameId = g.id;
        break;
      }
    }

    if (nextGameId) {
      this.selectedGameId = nextGameId;
      // console.log('going to next game, calling updateGameManually');
      (this.$refs.gameBoardComponent as GameBoardComponent).updateGameManually(
        this.selectedGameId
      );
    } else {
      // console.log('no other active games');
      this.showWarningSnackbar("You have no other active games at this time");
    }
  }

  public refresh() {
    // console.log('refresh data');
    if (this.showGameBoard) {
      this.getGames();
      // console.log('refreshing game, calling updateGameManually');
      (this.$refs.gameBoardComponent as GameBoardComponent).updateGameManually(
        this.selectedGameId
      );
    } else if (this.showGamesList) {
      this.getGames();
    } else if (this.showMyProfile) {
      this.getPlayerData();
      this.getFriends();
      this.getRequests();
    }
    this.showSuccessSnackbar("Reloaded data!");
  }

  public showHelp() {
    console.log('showHelp');
    this.helpContent.showHelp = true;
    if (this.showGameBoard) {
      this.helpContent.helpTitle = 'Help - Gameboard';
      this.helpContent.helpText = '<p>This is the Gameboard. It has 3 sections.</p>' +
        '<h5>Top Section</h5>' +
        '<p>The top section is a grid with nxm cells. If the cell is unoccupied, it will look like an empty square. If the cell is occupied, the color of the occupant indicates whether the Card belongs to you, or your opponent. The icon indicates the Card type.</p>' +
        '<h5>Middle Section</h5>' +
        '<p>The middle section shows the four Cards in your hand, how much energy you have, an indicator of whether or not it is your turn, and buttons to end your turn.</p>' +
        '<p>If you choose "Discard and End Turn", you will draw four random new Cards.</p>' +
        '<p>Energy is replenished and incremented after each turn.</p>' +
        '<p>You can only place Cards on the board in your territory, if it is your turn, and you have enough energy to place the Card. Warning messages will be shown for any illegal moves.</p>' +
        '<p>Each Card indicates the card type (Troop, Wall, Defense), movement direction (if any, Walls do not move), might (strength of the card), and cost (energy to be consumed to place the card).</p>' +
        '<p>Cards advance on their own, based on the movement direction, after they have been on the board for at least one turn. When your Card and an opponent\'s card reach the same cell on the board, the Card with the stronger might remains in the cell, and damage is taken.</p>' +
        '<p>When your Troop card makes it all the way to the other side of the board, you will score points based on how much might the Card still has.</p>' +
        '<h5>Last Section</h5>' +
        '<p>The last section shows various game stats. Hover over the icons to see what they indicate.</p>'
    } else if (this.showGamesList) {
      this.helpContent.helpTitle = 'Help - Games List';
      this.helpContent.helpText = '<p>This page lists your current games that are in various stages.</p>' +
        '<p>You can start a new 2-Player Game, which will match you up with another player, or you can start a game against an AI.</p>' +
        '<p>Mouse over the various icons of a game to see what they indicate.</p>' +
        '<p>Click <i class="fa fa-arrow-right"/> to go to the Gameboard.</p>';
    } else if (this.showMyProfile) {
      this.helpContent.helpTitle = 'Help - My Profile';
      this.helpContent.helpText = '<p>This page shows your overall stats, friends (if any), and any outgoing or pending requests.</p>' +
        '<p>You can request a new friend by searching for their username, and track their response.</p>' +
        '<p>Once a friend accepts your request, you can invite them to a game of Simple War! This is where the real fun begins.</p>' +
        '<p>Not only can you invite your friend to a regular/default Simple War, you can configure Advanced Options, such as board size, number of Cards per cell, drop rates of Card types, any much more. Explore and experiment with different configurations!</p>';
    }
  }

  public resetSnackbarState() {
    // console.log('resetting snackbar...');
    this.snackbarMessage = "";
    this.snackbarType = "";
  }

  public doLogin() {
    // console.log('showing login form');
    this.form = new LogRegForm();
    this.showLoginForm = true;
    this.showRegisterFrom = false;
  }

  public doRegister() {
    // console.log('showing register form');
    this.form = new LogRegForm();
    this.showLoginForm = false;
    this.showRegisterFrom = true;
  }

  public cancelLoginRegister() {
    this.form = new LogRegForm();
    this.showLoginForm = false;
    this.showRegisterFrom = false;
  }

  public doGuest() {
    // console.log('doing guest...');
    this.showLoginForm = false;
    this.showRegisterFrom = false;
    this.showOverview = false;
    this.showGuestMessage = true;
  }

  public cancelGuestMessage() {
    this.showGuestMessage = false;
    // console.log('cancelGuestMessage');
  }

  public confirmGuestMessage() {
    this.showGuestMessage = false;
    // console.log('confirmGuestMessage');
    this.$http.post(`${this.host}/users/register?isGuest=true`, {}).then(
      result => {
        if (result.ok && result.data) {
          this.user = result.data;
          this.$cookies.set(this.SESSION_TOKEN_STR, result.data.sessionToken);
          this.isAuthenticated = true;
          this.showLoginForm = false;
          this.showRegisterFrom = false;
          // console.log('successfully created guest user:', this.user);
          this.getGames();
          this.showSuccessSnackbar(
            `Successfully logged in as ${this.user.username}`
          );
          this.getDefaultConfigs();
          this.initializeWebSocketConnection();
        } else {
          throw new Error(JSON.stringify(result));
        }
      },
      error => {
        // console.log(error);
        this.showWarningSnackbar(error.body.message);
      }
    );
  }

  public doOverview() {
    // console.log('doing overview...');
    this.showLoginForm = false;
    this.showRegisterFrom = false;
    this.showGuestMessage = false;
    this.showOverview = true;
  }

  public validateAndSubmit() {
    const validationMessages: string[] = [];

    if (!this.form.username) {
      validationMessages.push(ErrorMessages.USERNAME_IS_REQUIRED);
    }

    if (!this.form.password) {
      validationMessages.push(ErrorMessages.PASSWORD_IS_REQUIRED);
    }

    if (this.showRegisterFrom) {
      if (this.form.password !== this.form.passwordConfirmation) {
        validationMessages.push(ErrorMessages.PASSWORDS_DO_NOT_MATCH);
      }
    }

    this.form.email = "test@test.com";

    if (validationMessages.length > 0) {
      this.showWarningSnackbar(validationMessages.join(", "));
    } else {
      const path = this.showLoginForm ? "login" : "register";
      // console.log(`posting to /${path}`);

      bcrypt.hash(this.form.password, 10, (err: any, hash: string) => {
        let passwordToUse = this.form.password;

        if (this.showRegisterFrom) {
          passwordToUse = hash;
        }

        this.$http
          .post(`${this.host}/users/${path}`, {
            username: this.form.username,
            password: passwordToUse,
            passwordConfirmation: passwordToUse,
            email: this.form.email
          })
          .then(
            result => {
              if (result.ok && result.data) {
                this.user = result.data;
                this.$cookies.set(
                  this.SESSION_TOKEN_STR,
                  result.data.sessionToken
                );
                this.isAuthenticated = true;
                this.showLoginForm = false;
                this.showRegisterFrom = false;
                // console.log('successfully authenticated user:', this.user);
                this.getGames();
                this.showSuccessSnackbar(
                  `Successfully logged in as ${this.user.username}`
                );
                this.getDefaultConfigs();
                this.initializeWebSocketConnection();
              } else {
                throw new Error(JSON.stringify(result));
              }
            },
            error => {
              // console.log(error);
              this.showWarningSnackbar(error.body.message);
            }
          );
      });
    }
  }

  public logout() {
    // console.log('logout');
    this.$http.get(`${this.host}/users/logout/${this.user.sessionToken}`).then(
      result => {
        if (result.ok) {
          this.$cookies.remove(this.SESSION_TOKEN_STR);
          this.isAuthenticated = false;
          this.user = new User();
          this.form = new LogRegForm();
          this.showGameBoard = false;
          this.showGamesList = true;
          this.showMyFriends = false;
          this.showMyProfile = false;
          this.selectedGameId = "";
          this.completed = [];
          this.games = [];
          this.pending = [];
          this.waiting = [];
          this.disconnectAndUnsubscribeWebSockets();
          // console.log('logout successful');
        } else {
          throw new Error(JSON.stringify(result));
        }
      },
      error => {
        // console.log(error);
        this.showWarningSnackbar(error);
      }
    );
  }

  public destroyed() {
    console.log("SimpleWarView destroyed");
    this.disconnectAndUnsubscribeWebSockets();
  }

  public disconnectAndUnsubscribeWebSockets() {
    console.log('disconnectAndUnsubscribeWebSockets');

    if (this.stompClient) {
      this.stompClient.disconnect(() => {
        if (this.opponentPutCardSubscription) {
          this.opponentPutCardSubscription.unsubscribe();
        }

        if (this.opponentEndTurnSubscription) {
          this.opponentEndTurnSubscription.unsubscribe();
        }

        if (this.friendRequestReceivedSubscription) {
          this.friendRequestReceivedSubscription.unsubscribe();
        }

        if (this.friendRequestResponseSubscription) {
          this.friendRequestResponseSubscription.unsubscribe();
        }

        if (this.invitedToGameSubscription) {
          this.invitedToGameSubscription.unsubscribe();
        }
      });
    }
  }

  public getAgoTime(dateStr: string, currentStr: string) {
    return getAgoTime(dateStr, currentStr);
  }
}
